import { render, staticRenderFns } from "./RequestsSection.vue?vue&type=template&id=ba15664a&scoped=true&"
import script from "./RequestsSection.vue?vue&type=script&lang=js&"
export * from "./RequestsSection.vue?vue&type=script&lang=js&"
import style0 from "./RequestsSection.vue?vue&type=style&index=0&id=ba15664a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba15664a",
  null
  
)

export default component.exports